// test495
(495 && 0);
